import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Ícono de Material Icons (la fuente que ya carga index.html). Sin `label` es decorativo y el
 * lector de pantalla lo ignora; con `label`, se anuncia como imagen con ese nombre.
 */
@Component({
  selector: 'sc-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span
    class="material-icons sck-icon"
    [attr.role]="label() ? 'img' : null"
    [attr.aria-label]="label()"
    [attr.aria-hidden]="label() ? null : 'true'"
    >{{ name() }}</span
  >`,
})
export class ScIconComponent {
  /** Ligadura de Material Icons (`search`, `close`, `expand_more`…). */
  readonly name = input.required<string>();
  readonly label = input<string | null>(null);
}
